import React, { Component, Fragment } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// Assuming fontawesome is set up similarly
const config = require("../config.json"); // May not be needed here unless displaying images

export default class Ingredient extends Component {
  constructor(props) {
    super(props);
    this.handleInputChange = this.handleInputChange.bind(this);
  }

  state = {
    isEditMode: false,
    // Local state for editing, initialized from props
    updatedIngredient: {
      id: "",
      name: "",
      name_en: "",
      category: "",
      image: "",
      nutrition: {
        kj: "",
        kcal: "",
        fat: "",
        carbohydrates: "",
        protein: "",
      },
      co2e: {
        totalKg: "",
        agriculture: "",
        iluc: "",
        processing: "",
        packaging: "",
        transport: "",
        detail: "",
      },
      // Add other fields
    },
  };

  componentDidMount() {
    // Initialize local state with prop data when component mounts
    // Deep copy nested objects to avoid direct state mutation issues
    this.setState({
      updatedIngredient: {
        ...(this.props.ingredient || {}), // Start with props
        image: this.props.ingredient.image || "", // Ensure image has a default
        nutrition: { ...(this.props.ingredient?.nutrition || {}) }, // Deep copy nutrition
        co2e: { ...(this.props.ingredient?.co2e || {}) }, // Deep copy co2e
        // Ensure default empty strings for nested properties if they don't exist
        nutrition: {
          kj: this.props.ingredient?.nutrition?.kj ?? "",
          kcal: this.props.ingredient?.nutrition?.kcal ?? "",
          fat: this.props.ingredient?.nutrition?.fat ?? "",
          carbohydrates: this.props.ingredient?.nutrition?.carbohydrates ?? "",
          protein: this.props.ingredient?.nutrition?.protein ?? "",
        },
        co2e: {
          totalKg: this.props.ingredient?.co2e?.totalKg ?? "",
          agriculture: this.props.ingredient?.co2e?.agriculture ?? "",
          iluc: this.props.ingredient?.co2e?.iluc ?? "",
          processing: this.props.ingredient?.co2e?.processing ?? "",
          packaging: this.props.ingredient?.co2e?.packaging ?? "",
          transport: this.props.ingredient?.co2e?.transport ?? "",
          detail: this.props.ingredient?.co2e?.detail ?? "",
        },
      },
    });
  }

  // Handle input changes for the edit form (supports nested state)
  handleInputChange = (event) => {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value; // Keep for potential future use
    const name = target.name;

    if (name.includes(".")) {
      // Handle nested state (e.g., name="nutrition.kcal")
      const [parentKey, childKey] = name.split(".");
      this.setState((prevState) => ({
        updatedIngredient: {
          ...prevState.updatedIngredient,
          [parentKey]: {
            ...prevState.updatedIngredient[parentKey],
            [childKey]: value,
          },
        },
      }));
    } else {
      // Handle top-level state
      this.setState({
        updatedIngredient: {
          ...this.state.updatedIngredient,
          [name]: value,
        },
      });
    }
  };

  // Toggle edit mode
  handleIngredientEdit = (event) => {
    event.preventDefault();
    // If entering edit mode, ensure state is synced with latest props (optional but safer)
    if (!this.state.isEditMode) {
      this.setState({
        updatedIngredient: {
          ...(this.props.ingredient || {}),
          nutrition: { ...(this.props.ingredient?.nutrition || {}) },
          co2e: { ...(this.props.ingredient?.co2e || {}) },
          nutrition: {
            kj: this.props.ingredient?.nutrition?.kj ?? "",
            kcal: this.props.ingredient?.nutrition?.kcal ?? "",
            fat: this.props.ingredient?.nutrition?.fat ?? "",
            carbohydrates:
              this.props.ingredient?.nutrition?.carbohydrates ?? "",
            protein: this.props.ingredient?.nutrition?.protein ?? "",
          },
          co2e: {
            totalKg: this.props.ingredient?.co2e?.totalKg ?? "",
            agriculture: this.props.ingredient?.co2e?.agriculture ?? "",
            iluc: this.props.ingredient?.co2e?.iluc ?? "",
            processing: this.props.ingredient?.co2e?.processing ?? "",
            packaging: this.props.ingredient?.co2e?.packaging ?? "",
            transport: this.props.ingredient?.co2e?.transport ?? "",
            detail: this.props.ingredient?.co2e?.detail ?? "",
          },
        },
      });
    }
    this.setState({ isEditMode: !this.state.isEditMode });
  };

  // Save changes by calling the handler passed from IngredientAdmin
  handleEditSave = (event) => {
    event.preventDefault();
    this.setState({ isEditMode: false });
    this.props.handleUpdateIngredient(this.state.updatedIngredient);
  };

  // Create a copy by calling the handler passed from IngredientAdmin
  handleIngredientCopy = (event) => {
    event.preventDefault(); // Prevent default form submission if it's a button in a form
    this.setState({ isEditMode: false }); // Exit edit mode if copying from there
    // Pass the current state (which might have unsaved edits if copied from edit mode)
    // The 'true' flag tells handleAddIngredient it's a copy operation
    this.props.handleAddIngredient(this.state.updatedIngredient, event, true);
  };

  render() {
    const { ingredient, handleDeleteIngredient, isAdmin } = this.props; // Destructure props
    const { updatedIngredient, isEditMode } = this.state; // Destructure state
    const s3ImageUrlPrefix = config.s3.ingredientImagesUrl;

    // Handle case where ingredient data might be initially undefined
    if (!ingredient && !isEditMode) {
      return <div className="box notification">Ingrediens data mangler.</div>;
    }

    return (
      <div
        className={`box notification is-near-half m-small ${
          this.props.className || ""
        }`}
      >
        {isAdmin && (
          <Fragment>
            {!isEditMode && ( // Show edit icon only in display mode
              <a
                href="#" // Avoid navigation, use button or preventDefault
                onClick={this.handleIngredientEdit}
                className="product-edit-icon" // Reuse class name?
                style={{
                  position: "absolute",
                  top: "10px",
                  right: "40px",
                  cursor: "pointer",
                }} // Example style
              >
                <FontAwesomeIcon icon="edit" />
              </a>
            )}
            <button
              onClick={(event) =>
                handleDeleteIngredient(updatedIngredient.id, event)
              }
              className="delete" // Standard Bulma delete button
            ></button>
          </Fragment>
        )}

        {isEditMode ? (
          // --- Edit Mode Form ---
          <div>
            <h4 className="title is-6">Rediger Ingrediens</h4>
            <div className="field">
              <label className="label is-small">Navn</label>
              <input
                name="name"
                className="input is-small"
                type="text"
                value={updatedIngredient.name}
                onChange={this.handleInputChange}
              />
            </div>
            <div className="field">
              <label className="label is-small">Kategori</label>
              <input
                name="category"
                className="input is-small"
                type="text"
                value={updatedIngredient.category}
                onChange={this.handleInputChange}
              />
            </div>

            <div className="field">
              <label className="label is-small">Billede</label>
              <div className="select is-small is-fullwidth">
                <select
                  name="image"
                  value={updatedIngredient.image || ""}
                  onChange={this.handleInputChange}
                >
                  <option value="">Intet billede</option>
                  {(this.props.ingredientImages || []).map((img) => (
                    <option key={img.Key} value={img.Key}>
                      {img.Key}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            {/* Nutrition Fields */}
            <fieldset className="box">
              <legend className="label is-small">Næringsindhold</legend>
              <div className="field">
                <label className="label is-small">kJ</label>
                <input
                  name="nutrition.kj"
                  type="number"
                  step="any"
                  className="input is-small"
                  value={updatedIngredient.nutrition?.kj ?? ""}
                  onChange={this.handleInputChange}
                />
              </div>
              <div className="field">
                <label className="label is-small">kcal</label>
                <input
                  name="nutrition.kcal"
                  type="number"
                  step="any"
                  className="input is-small"
                  value={updatedIngredient.nutrition?.kcal ?? ""}
                  onChange={this.handleInputChange}
                />
              </div>
              <div className="field">
                <label className="label is-small">Fedt (g)</label>
                <input
                  name="nutrition.fat"
                  type="number"
                  step="any"
                  className="input is-small"
                  value={updatedIngredient.nutrition?.fat ?? ""}
                  onChange={this.handleInputChange}
                />
              </div>
              <div className="field">
                <label className="label is-small">Kulhydrat (g)</label>
                <input
                  name="nutrition.carbohydrates"
                  type="number"
                  step="any"
                  className="input is-small"
                  value={updatedIngredient.nutrition?.carbohydrates ?? ""}
                  onChange={this.handleInputChange}
                />
              </div>
              <div className="field">
                <label className="label is-small">Protein (g)</label>
                <input
                  name="nutrition.protein"
                  type="number"
                  step="any"
                  className="input is-small"
                  value={updatedIngredient.nutrition?.protein ?? ""}
                  onChange={this.handleInputChange}
                />
              </div>
            </fieldset>

            {/* CO2e Fields */}
            <fieldset className="box">
              <legend className="label is-small">CO2e Aftryk</legend>
              <div className="field">
                <label className="label is-small">Total Kg CO2e</label>
                <input
                  name="co2e.totalKg"
                  type="number"
                  step="any"
                  className="input is-small"
                  value={updatedIngredient.co2e?.totalKg ?? ""}
                  onChange={this.handleInputChange}
                />
              </div>
              <div className="field">
                <label className="label is-small">Landbrug</label>
                <input
                  name="co2e.agriculture"
                  type="number"
                  step="any"
                  className="input is-small"
                  value={updatedIngredient.co2e?.agriculture ?? ""}
                  onChange={this.handleInputChange}
                />
              </div>
              <div className="field">
                <label className="label is-small">ILUC</label>
                <input
                  name="co2e.iluc"
                  type="number"
                  step="any"
                  className="input is-small"
                  value={updatedIngredient.co2e?.iluc ?? ""}
                  onChange={this.handleInputChange}
                />
              </div>
              <div className="field">
                <label className="label is-small">Forarbejdning</label>
                <input
                  name="co2e.processing"
                  type="number"
                  step="any"
                  className="input is-small"
                  value={updatedIngredient.co2e?.processing ?? ""}
                  onChange={this.handleInputChange}
                />
              </div>
              <div className="field">
                <label className="label is-small">Emballage</label>
                <input
                  name="co2e.packaging"
                  type="number"
                  step="any"
                  className="input is-small"
                  value={updatedIngredient.co2e?.packaging ?? ""}
                  onChange={this.handleInputChange}
                />
              </div>
              <div className="field">
                <label className="label is-small">Transport</label>
                <input
                  name="co2e.transport"
                  type="number"
                  step="any"
                  className="input is-small"
                  value={updatedIngredient.co2e?.transport ?? ""}
                  onChange={this.handleInputChange}
                />
              </div>
              <div className="field">
                <label className="label is-small">Detail</label>
                <input
                  name="co2e.detail"
                  type="number"
                  step="any"
                  className="input is-small"
                  value={updatedIngredient.co2e?.detail ?? ""}
                  onChange={this.handleInputChange}
                />
              </div>
            </fieldset>

            {/* Removed fields specific to Activity */}

            <p
              className="product-id"
              style={{ fontSize: "0.8em", color: "#777", marginTop: "10px" }}
            >
              ID: {updatedIngredient.pk}
            </p>
            <div className="buttons are-small mt-2">
              <button
                type="button" // Use type button to prevent form submission
                className="button is-success"
                onClick={this.handleEditSave}
              >
                Gem Ændringer
              </button>
              <button
                type="button"
                className="button is-link is-light"
                onClick={this.handleIngredientCopy}
              >
                Opret Kopi
              </button>
              <button
                type="button"
                className="button is-light"
                onClick={this.handleIngredientEdit} // Re-use to exit edit mode
              >
                Annuller
              </button>
            </div>
          </div>
        ) : (
          // --- Display Mode ---
          <div style={{ width: "100%" }}>
            <p className="product-title title is-5">{updatedIngredient.name}</p>{" "}
            <p>
              <b>Engelsk navn:</b> {updatedIngredient.name_en}
            </p>
            {updatedIngredient.image && (
              <figure className="image is-64x64 mb-2">
                {/* Smaller image for ingredient list */}
                <img
                  src={`${s3ImageUrlPrefix}${updatedIngredient.image}`}
                  alt={updatedIngredient.name}
                />
              </figure>
            )}
            {/* Use state for consistency */}
            <p>
              <b>Kategori:</b> {updatedIngredient.category}
            </p>
            <hr style={{ margin: "0.5rem 0" }} />
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                flexWrap: "wrap",
              }}
            >
              <div style={{ marginRight: "20px" }}>
                <p>
                  <b>Næringsindhold:</b>
                </p>
                <ul
                  style={{
                    listStyle: "none",
                    paddingLeft: "10px",
                    fontSize: "0.9em",
                  }}
                >
                  <li>kJ: {updatedIngredient.nutrition?.kj}</li>
                  <li>kcal: {updatedIngredient.nutrition?.kcal}</li>
                  <li>Fedt: {updatedIngredient.nutrition?.fat} g</li>
                  <li>
                    Kulhydrat: {updatedIngredient.nutrition?.carbohydrates} g
                  </li>
                  <li>Protein: {updatedIngredient.nutrition?.protein} g</li>
                </ul>
              </div>
              <div>
                <p>
                  <b>CO2e Aftryk (kg/kg):</b>
                </p>
                <ul
                  style={{
                    listStyle: "none",
                    paddingLeft: "10px",
                    fontSize: "0.9em",
                  }}
                >
                  <li>Total: {updatedIngredient.co2e?.totalKg}</li>
                  <li>Landbrug: {updatedIngredient.co2e?.agriculture}</li>
                  <li>ILUC: {updatedIngredient.co2e?.iluc}</li>
                  <li>Forarb.: {updatedIngredient.co2e?.processing}</li>
                  <li>Embal.: {updatedIngredient.co2e?.packaging}</li>
                  <li>Transp.: {updatedIngredient.co2e?.transport}</li>
                  <li>Detail: {updatedIngredient.co2e?.detail}</li>
                </ul>
              </div>
            </div>
            {/* Removed Activity-specific fields like descriptions, points etc */}
            <p
              className="product-id"
              style={{ fontSize: "0.8em", color: "#777", marginTop: "10px" }}
            >
              ID: {updatedIngredient.pk}
            </p>
          </div>
        )}
      </div>
    );
  }
}
